<template>
  <div
    class="scheduleMain"
  >
    <v-layout>
      <interval-times
        :label="`${$t('schedule.startTime')}:`"
        v-model="startTime"
      />
      <interval-times
        :label="`${$t('schedule.interval')}:`"
        v-model="interval"
      />
    </v-layout>
    <v-layout>
      <table class="timeline">
        <tr
          v-for="(item, index) in timetable"
          :key="`rowSchedule${index}`"
        >
          <td class="timeline-day">
            <span :style="{'color': index == 0 ? '#F4433699' : '' }">{{$t(`common.dayOfWeek.${index}`).toUpperCase()}}</span>
            <custom-dialog
              :key="`force24${index}`"
              title="Superado el límite"
              message="El tramo supera las 24h, ¿quiere establecerlo a esa hora?"
              :index="index"
              :showDialog="showForce24"
              :onKO="function() { showForce24 = false }"
              :onOK="handleForce24"
            />
            <custom-dialog
              title="Superado el límite"
              message="El tramo no puede superar las 24h"
              :showDialog="showLimit24"
              :onKO="function() { showLimit24 = false }"          
            />
          </td>
          <td width="auto">
            <schedule-day
              :data="item"
              :index="parseInt(index)"
              :onChange="(data, i) => timetable[index] = data"
            />
          </td>
          <td class="timeline-action">
            <v-icon @click="handleAddSection(item, index)" color="green">
              mdi-plus
            </v-icon>
            <v-dialog v-model="copyDialog" persistent max-width="590">
              <template v-slot:activator="{ on }">
                 <v-icon v-on="on" style="margin-left:5px;" color="blue"
                  @click="actualIndex=index"
                 >
                  mdi-content-copy
                </v-icon>                
              </template>
              <v-card>
                <v-card-text class="headline" style="padding-top: 15px;">Días en los que copiar los valores</v-card-text>
                <center style="padding-top: 5px;padding-left: 10px;">
                  <v-btn
                    v-for="(tt, copyDayIndex) in timetable"
                    :key="`copy${copyDayIndex}`"
                    style="margin-right: 10px;"
                    :color="copySelected.indexOf(copyDayIndex) >= 0 ? 'green' : 'white'"
                    @click="() => handleSelectedCopy(copyDayIndex)"
                  >
                    {{$t(`common.dayOfWeek.${copyDayIndex}`).substring(0, 3).toUpperCase()}}
                  </v-btn>
                </center>
                <!-- <v-card-text>{{message}}</v-card-text> -->
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="gray darken-1" text @click="handleCopyKO">{{$t('common.cancel')}}</v-btn>
                  <v-btn color="green darken-1" text @click="handleCopyOK">{{$t('common.ok')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-icon @click="handleDeleteSection(index)" color="red">
              mdi-delete
            </v-icon>                                
          </td>
        </tr>
      </table>
    </v-layout>
  </div>
</template>

<script>
  import utils from '@/services/utils'
  import api from '@/services/api'
  import IntervalTimes from '@/components/intervalTimes/Index'
  import ScheduleDay from './ScheduleDay'
  import CustomDialog from '@/components/CustomDialog'
  export default {
    components: {
      IntervalTimes,
      ScheduleDay,
      CustomDialog
    },
    props: {
      value: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        copySelected: [], // utilizado para el duplicar por semana
        copyDialog: false, // utilizado para el duplicar por semana
        startTime: 480,
        interval: 30,
        timetable: {
          0: [],
          1: [],
          2: [],
          3: [],
          4: [],
          5: [],
          6: []
        },
        actualIndex: null,
        showForce24: false,
        showLimit24: false
      }
    },
    computed: {
      ID () {
        return this.$route.params.id
      },
    },
    watch: {
      value: {
        handler: function (newValue) {
          if (newValue != null) {
            this.timetable = newValue
          }
        },
        deep: true
      }
    },
    mounted () {
      if (this.value) this.timetable = this.value
      // api.getItem('morfos', true, this.ID).then(response => {
      //   console.log('jhm4', response)
      //   this.startTime = response.StartTimeDefault
      //   this.interval = response.Duration
      // })
    },
    methods: {
      handleAddSection (item, index) {          
        if (item.length > 0) {
          let aux = item[item.length - 1]
          let minutes = aux.minutes + (aux.hours * 60)
          minutes = minutes + this.interval
          if (minutes > 1440) {
            if (item.filter(x => x.hours === 24 && x.minutes === 0).length > 0) {
              this.showLimit24 = true
            } else {
              this.actualIndex = index
              this.showForce24 = true
            }            
          } else {
            item.push(utils.convertMinutesToTime(minutes))
          }          
        } else {
          item = []
          item.push(utils.convertMinutesToTime(this.startTime))
        }
        this.timetable[index] = item
        this.updateChange()
      },
      handleDeleteSection(index) {
        this.timetable[index] = []
        this.updateChange()
      },
      handleForce24() {
        if(this.actualIndex) {
          this.timetable[this.actualIndex].push(utils.convertMinutesToTime(1440))
          this.showForce24 = false
          this.actualIndex = null
          this.updateChange()
        }        
      },
      handleSelectedCopy (value) {
        if (this.copySelected.indexOf(value) >= 0) {
          this.copySelected = this.copySelected.filter(x => x!== value)
        } else {
          this.copySelected.push(value)
        }
      },      
      handleCopyKO () {
        this.copySelected = []
        this.copyDialog = false
        this.actualIndex = null
      },
      handleCopyOK () {
        this.copySelected.forEach(item => {
          this.timetable[item] = JSON.parse(JSON.stringify(this.timetable[this.actualIndex]))
        })
        this.copySelected = []
        this.copyDialog = false
        this.actualIndex = null
        this.updateChange()
      },
      updateChange() {
        this.$emit('input', this.timetable)
      }
    }
  }
</script>
<style scoped>
  .scheduleMain {
    background-color: lightblue;
    width: 100%;
  }
  .timeline {
    width: 100%;
  }
  .timeline tr {
    height: 40px;;
  }
  .timeline-day {
    font-weight: 700;
    width: 100px;
    text-align: right;
    color: #00000099;
  }
  .timeline-action {
    width: 80px;
  }
</style>
